// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { SuccessAlert } from "wbm-generic-components";

export interface IErrorAlertProps {
  show: boolean;
  onClickClose: () => void;
}

export const ErrorAlert = ({ show, onClickClose }: IErrorAlertProps) => {
  if (!show) return null;
  return (
    <SuccessAlert
      show={show}
      timerLengthInMS={3500}
      danger
      dangerText="Please try again. If the problem persists, please call 1-888-WB-MASON."
      dangerAttentionText="An error has occurred!"
      onClickClose={onClickClose}
    />
  );
};
